import React from "react";

import { Header as StyledHeader, LinkMenu } from "./styles";
import { useEffect } from "react";
import { useRef } from "react";

import { signOut } from "../../services/security";

function Header({ links, theme }) {
  const headerRef = useRef();

  const handleDocumentScrollThrottled = (e) => {
    if (document.documentElement.scrollTop > 0) {
      headerRef.current.style.backgroundColor = "#000C";
      for (let i = 0; i < headerRef.current.children.length; i++) {
        headerRef.current.children[i].style.color = "#FFF";
        headerRef.current.children[i].style.fontWeight = "normal";
      }
    } else {
      headerRef.current.style.backgroundColor = "#0000";
      for (let i = 0; i < headerRef.current.children.length; i++) {
        if(headerRef.current.children[i]){

        }
        headerRef.current.children[i].style.color = "#000";
        headerRef.current.children[i].style.fontWeight = "bold";
      }
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleDocumentScrollThrottled);

    return () =>
      window.removeEventListener("scroll", handleDocumentScrollThrottled);
  }, []);

  const sair = () => {
    signOut();
  };

  return (
    <StyledHeader ref={headerRef}>
      {links.map((l) => (
        <LinkMenu
          key={l.to}
          theme={theme}
          to={l.to}
          style={l.highlight}
          onClick={l.to === "/" ? sair : () => {}}
        >
          {l.label}
        </LinkMenu>
      ))}
    </StyledHeader>
  );
}

export default Header;
